import React from "react";
import styles from "./styles.module.scss";

const ScheduleItem = ({ schedule }: any) => {

  const month = schedule.date.split(" ")[0];
  const day = schedule.date.split(" ")[1];

  const duration = schedule.duration + " mins";

  return (
    <div className={styles.container}>
      <div className={styles.date}>
        <div className={styles.month}>{month}</div>
        <div className={styles.day}>{day}</div>
      </div>

      <div className={styles.content}>
        <div className={styles.title}>{schedule.title || "Custom"}</div>
        <div className={styles.user_profile}>
          <img className={styles.profile_image} src={schedule.profile_image} alt={"profile_image"}/>
          <div className={styles.name}>{schedule.name}</div>
        </div>
      </div>

      <div className={styles.time_container}>
        <div className={styles.time}>{schedule.time}</div>
        <div>{duration}</div>
      </div>
    </div>
  );
};

export default ScheduleItem;
